import React from 'react';
// import { useTranslation } from 'react-i18next';
import {
  FormPublicDesignFragment,
  FormPublicPageFragment,
  FormPublicFieldFragment,
} from '../../../graphql/fragment/form.public.fragment';
import { StyledButton } from '@/components/styled/button';
// import { StyledButton } from '../../../styled/button';
// import { StyledH1 } from '../../../styled/h1';
// import { StyledMarkdown } from '../../../styled/markdown';
// import { PageButtons } from '../page.buttons'
import { StartImage } from '../../start.image';
import { Box, Grid, Typography } from '@mui/material';
// import scss from './page.module.scss';

interface Props {
  page: FormPublicPageFragment;
  design: FormPublicDesignFragment;
  className?: string;
  image?: boolean;

  next?: () => void;
  prev?: () => void;
  showProgress?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FormPage: React.FC<Props> = ({
  page,
  design,
  image,
  next,
  prev,
  className,
  showProgress,
}) => {
  // const { t } = useTranslation();

  if (!page.show) {
    return null;
  }

  return (
    <Grid
      sx={{
        marginTop: '113px', // header logo height
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'calc(100vh - 113px)',
        padding: ['0 24px', '0 24px', '0 20vw'],
      }}
    >
      <Grid item>
        {image && (
          <StartImage
            design={design}
            url={page.imageURL ? page.imageURL : ''}
          />
        )}
      </Grid>
      <Grid item>
        <Typography
          sx={{ typography: { sm: 'h4', xs: 'h5' } }}
          style={{ color: design.colors.question }}
        >
          {page.title}
        </Typography>
      </Grid>
      <Grid item>
        <Typography
          style={{
            color: design.colors.question,
            whiteSpace: 'pre-wrap',
            padding: '5vh 0',
          }}
        >
          {page.paragraph}
        </Typography>
      </Grid>
      {className === 'start-page' && (
        <StyledButton
          background={design.colors.button}
          $buttonColor={design.colors.buttonText}
          highlight={design.colors.buttonActive}
          className={'continue-button'}
          // size={'large'}
          onClick={() => {
            if (showProgress !== undefined && next !== undefined) {
              showProgress(true);
              next();
            }
          }}
        >
          {page.buttonText || 'Get Started'}
        </StyledButton>
      )}
      {className === 'end-page' && page.buttonText && (
        <StyledButton
          background={design.colors.button}
          $buttonColor={design.colors.buttonText}
          highlight={design.colors.buttonActive}
          className={'continue-button'}
          // size={'large'}
          onClick={() => {
            if (showProgress !== undefined && prev !== undefined) {
              showProgress(false);
              prev();
            }
          }}
        >
          {page.buttonText}
        </StyledButton>
      )}
    </Grid>
  );
};
